//#region Styles
import { Tooltip } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Icons
import ArrowIcon from "icons/ArrowIcon";
//#endregion

const NavigateButton = ({
    next = false,
    firstOrLast = false,
    changeCurrentPage,
    tooltipText
}) => {
    const getClassName = () => {
        const classList = [];
        next && classList.push("next");
        firstOrLast && classList.push("first-or-last");
        return classList.join(" ");
    }
    return (
        <Container 
            className={getClassName()}
            onClick={changeCurrentPage}>
            <ArrowIcon/>
            <Tooltip>{tooltipText}</Tooltip>
        </Container>
    );
}

export default NavigateButton;